<template lang="pug">
ul.links.flex_h
  li(v-for="(link, index) in links", :key="index", :class="linkClasses(link)")
    a(v-if="link.url", :href="link.url") {{ link.name }}
    router-link(v-else, tag="a", :to="{ name: link.pageName }")
      | {{ link.name }}
</template>
<script>
export default {
  name: "Links",
  data() {
    return {
      links: [
        // {
        //   name: "網路投保",
        //   url: "https://www.tmnewa.com.tw/b2c_v2/frontstage/welcome.aspx",
        // },
        {
          name: "商品櫥窗",
          pageName: "Product",
        },
        {
          name: "客戶服務",
          pageName: "CustomerService",
        },
        {
          name: "認識我們",
          pageName: "AboutUs",
        },
        {
          name: "公平待客",
          pageName: "customize",
          url: "/customize/manager",
        },
      ],
    };
  },
  methods: {
    linkClasses(link) {
      const route = this.$route || {};
      const keyword = link.pageName;

      if (!keyword) return {};

      const nameMatch =
        route.name &&
        String(route.name).toLowerCase().includes(keyword.toLowerCase());

      const pathMatch =
        route.path &&
        String(route.path).toLowerCase().includes(keyword.toLowerCase());

      const isMatch = nameMatch || pathMatch;

      return {
        selected: isMatch && this.$store.state.navigationStyle === 1,
        business: isMatch && this.$store.state.navigationStyle === 2,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/footer/link";
</style>
